import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { InactivityTimerService } from '../../../core/services/inactivity-timer.service';

@Component({
  selector: 'app-inactivity-timer-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/60 p-4">
      <div class="w-full max-w-lg rounded-3xl bg-white p-6 shadow-2xl ring-1 ring-black/10 dark:bg-slate-900 dark:ring-white/10">
        <div class="flex flex-col items-center gap-4 text-center px-2 py-3">
          <div class="flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-red-600 ring-1 ring-red-200">
            <i class="pi pi-exclamation-triangle text-3xl"></i>
          </div>

          <div>
            <p class="text-sm font-semibold uppercase tracking-[0.28em] text-orange-500">Alerta de inactividad</p>
            <h2 class="mt-3 text-2xl font-semibold text-slate-900 dark:text-slate-100">Tu sesión está a punto de expirar</h2>
            <p class="mt-2 text-sm text-slate-500 dark:text-slate-400">
              Por tu seguridad, cerraremos tu sesión automáticamente.
            </p>
          </div>

          <div class="w-full rounded-3xl bg-red-50 p-4 text-center shadow-sm ring-1 ring-red-100">
            <span class="block text-sm font-semibold text-slate-500">Tiempo restante</span>
            <span class="mt-2 block text-4xl font-bold text-red-600">{{ remainingTime() }}</span>
          </div>

          <div class="grid w-full grid-cols-2 gap-3 pt-3">
            <button
              type="button"
              class="box-border h-10 w-full sm:w-auto shrink-0 inline-flex items-center justify-center gap-2 px-5 border border-slate-300 bg-white text-sm font-semibold text-slate-700 rounded-md shadow-sm transition hover:border-slate-400 hover:bg-slate-50 cursor-pointer"
              (click)="onLogout()"
            >
              Cerrar sesión
            </button>

            <button
              type="button"
              class="box-border h-10 w-full sm:w-auto shrink-0 inline-flex items-center justify-center gap-2 px-5 bg-primary hover:bg-primary-900 text-white text-sm font-semibold rounded-md shadow-sm transition cursor-pointer"
              (click)="onReactivate()"
            >
              Continuar sesión
            </button>
          </div>

          <p class="mt-4 text-xs text-slate-500 dark:text-slate-400">
            Presiona Continuar sesión para mantener tu sesión activa.
          </p>
        </div>
      </div>
    </div>
  `,
  styles: [
    `:host { display:block; }`
  ],
})
export class InactivityTimerDialogComponent {
  private readonly inactivityTimer = inject(InactivityTimerService);

  readonly remainingTime = computed(() =>
    this.inactivityTimer.formatTimeRemaining(this.inactivityTimer.remainingTimeMs()),
  );

  onReactivate(): void {
    this.inactivityTimer.reactivate();
  }

  onLogout(): void {
    this.inactivityTimer.logoutNow();
  }
}